module.exports = __webpack_public_path__ + "img/foot.3a6117ee.png";